import { ActionName, ILink } from '../interfaces/links';
import { ISelectorData } from '../components/application/NewApplication';
import { IOrderFilters } from '../store/order/actions/order';
import { MRT_SortingState } from 'material-react-table';

export const getLink = (links: ILink[], actionName: ActionName): ILink | undefined => {
    const link = links?.find((link) => link?.actionName === actionName);
    return link;
};

export const getLinkField = (links: ILink[], actionName: ActionName, field: keyof ILink): string | undefined => {
    const link = getLink(links, actionName);

    return link?.[field];
};

export const getSelectedStatuses = (orderStatusesList: ISelectorData[], appliedFilters: IOrderFilters): string[] => {
    if (!orderStatusesList?.length) {
        return [];
    }
    const typeIndex = orderStatusesList?.length -1;

    if (appliedFilters?.types && appliedFilters?.status) {
        if (Array.isArray(appliedFilters?.status)) {
            return [...appliedFilters.status ?? [], String(typeIndex)];
        } else if (typeof appliedFilters?.status === 'string') {
            return [appliedFilters?.status, String(typeIndex)];
        }

    } else if (appliedFilters?.status) {
        if (Array.isArray(appliedFilters?.status)) {
            return appliedFilters?.status;
        } else if (typeof appliedFilters?.status === 'string') {
            return [appliedFilters?.status];
        }

    } else if (appliedFilters?.types) {
        return [String(typeIndex)];
    }
};

export const getTableSort = (sorting: MRT_SortingState): string => {
    if (!sorting?.length) {
        return '';
    }

    return sorting?.[0]?.desc ? 'desc' : 'asc';
};

export const getTableSortField = (sorting: MRT_SortingState): string => {
    return sorting?.length ? sorting[0].id : '';
};

